<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span
      >
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <div class="my-2">
              <h3 class="text-base font-medium text-gray-500">
                {{ message }}
              </h3>
            </div>
            <div v-if="type == 'checkbox' || type == 'radio'" class="flex flex-col">
              <label
                v-for="(choice, index) in choices"
                :key="index"
                class="inline-flex items-center mt-3">
                <input
                  v-if="choice"
                  :type="type"
                  class="form-checkbox h-5 w-5 text-yellow-600 mx-2"
                  v-model="target"
                  :value="choice['id']">
                <span class="ml-2 text-gray-700">{{ getValueProperty(choice, true) }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-between">
          <button
            @click="$emit('selected-target', target); close()"
            type="button"
            class="px-8 py-2 rounded bg-yellow-500 text-blue-50 max-w-max shadow-sm hover:shadow-md">
            Save
          </button>
          <button
            @click="close()"
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MultipleChoices',
  props: {
    message: {
      type: String,
      required: true
    },
    choices: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    propertyTarget: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      target: null
    }
  },
  computed: {
    ...mapGetters('account', {
      lang: 'defaultLang'
    })
  },
  methods: {
    getValueProperty: function (choice, multilang) {
      if (multilang) {
        return choice[this.propertyTarget][this.lang]
      } else if (!multilang) {
        return choice[this.propertyTarget]
      }
    },
    close () {
      this.$emit('close', true)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/others/utils/ModalMultipleChoices.vue